import './App.less'
import React, { FC } from 'react'
import { HashRouter as Router } from 'react-router-dom'
import Routes from './Routes'

const App: FC = () => (
	<Router>
		<Routes />
	</Router>
)

export default App
